import { ISfBankAccount } from '@sparling/financial-common'
import { IColumns } from '../../../../components/Table'

export type BankAccountsColumnKeys = 'id' | 'currency' | 'bankName' | 'description' | 'bankFees' | 'actions'

export const columns: IColumns<BankAccountsColumnKeys, ISfBankAccount>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'currency',
    label: 'Currency',
  },
  {
    id: 'bankName',
    label: 'Bank Name',
  },
  {
    id: 'description',
    label: 'Description',
  },
  {
    id: 'bankFees',
    label: 'Bank Fees',
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    format: (...args) => {
      const [, , , , row] = args
      return `${row?.moneyInFees} / ${row?.moneyOutFees} / ${row?.wireFees}`
    },
  },
  {
    id: 'actions',
    label: 'ACTION',
  },
]
